export default {
    path: '/place',
    name: 'Place',
    component: () => import(/* webpackChunkName: "place" */ '../../views/place/place.vue')
}